var borders_default = {
  "borderT": "JDuRB",
  "borderB": "iM4Za",
  "borderL": "-SA1V",
  "borderR": "LQ9hk",
  "borderColorOverride": "_0AD6j"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
